import * as React from 'react';

export interface ISearchResultsLayoutContext {
  isFluid: boolean;
  isMobile: boolean;
}

export const SearchResultsLayoutContext = React.createContext<
  ISearchResultsLayoutContext
>({
  isFluid: false,
  isMobile: false,
});
